<template>
  <v-dialog v-model="dialog" fullscreen persistent no-click-animation hide-overlay transition="dialog-bottom-transition">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{$t('Create an Account')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="closeForm"><i class="fas fa-times"></i></v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <ul v-if="returnErrors && returnErrors.length" class="errors-wrapper">
      <li v-for="error of returnErrors">
        <span v-if="error === 'The email has already been taken.'">
          {{$t('The email has already been taken.')}} <router-link to="/forgotpassword">{{$t('HERE!')}}</router-link>
        </span>
        <span v-else>
          {{$t(error)}}
        </span>
      </li>
    </ul>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field
              v-model="form.firstName"
              :label="$t('Firstname')"
              :rules="nameRule"
              required>
            </v-text-field>
          </v-flex>

          <v-flex xs6>
            <v-text-field
              v-model="form.lastName"
              :rules="nameRule"
              :label="$t('Lastname')"
              required>
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="form.phone"
              :rules="phoneRule"
              :label="$t('Phone')"
              required>
            </v-text-field>
          </v-flex>

          <v-flex xs6>
            <v-text-field
              v-model="form.email"
              :rules="emailRule"
              :label="$t('E-mail')"
              required>
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="form.address"
              :label="$t('Address')"
              :rules="addressRule"
              required>
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <div class="select-wrapper" data-app>
              <v-select
                v-model="form.sex"
                item-text="text"
                item-value="value"
                :items="this.gender"
                :label="$t('Sex')"
                :rules="genderRule"
                required>
              </v-select>
            </div>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="form.password"
              :label="$t('Password')"
              :type="'password'"
              :rules="passwordRule"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="form.password_repeat"
              :label="$t('Password repeat')"
              :type="'password'"
              :rules="passwordConfirmationRule"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              v-model="form.newsLetterSubscription"
              :label="$t('Subscribe newsletter')"
              color="primary">
            </v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              v-model="form.notifyBySms"
              :label="$t('SMS notifications')"
              color="primary">
            </v-checkbox>
          </v-flex>
          <v-flex>
            <div class="button-wrapper">
              <v-btn :disabled="!valid" color="success" @click="submit">{{$t('Create an Account')}}</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-snackbar v-model="snackbar" :timeout="5000" :top="true" :vertical="true">
      {{$t('User info saved!')}}
      <v-btn flat @click="snackbar = false">
        {{$t('Close')}}
      </v-btn>
    </v-snackbar>
  </v-dialog>
</template>

<script>
    import axios from 'axios';
    export default {
        data () {
            return {
                snackbar: false,
                valid: true,
                userData: [],
                nameRule: [
                    v => !!v || this.$t('Required field'),
                    v => (v && v.length >= 2) || this.$t('Must be at least 2 characters')
                ],
                addressRule: [
                    v => !!v || this.$t('Required field'),
                    v => (v && v.length >= 10) || this.$t('Must be at least 10 characters')
                ],
                emailRule: [
                    v => !!v || this.$t('Required field'),
                    v => /.+@.+/.test(v) || this.$t('E-mail must be valid')
                ],
                phoneRule: [
                    v => !!v || this.$t('Required field'),
                    v => (v && v.length >= 5) || this.$t('Must be at least 5 numbers')
                ],
                genderRule: [
                    v => !!v || this.$t('Required field')
                ],
                passwordRule: [
                    v => !!v || this.$t('Required field'),
                    v => (v && v.length >= 5) || this.$t('Must be at least 5 characters')
                ],
                passwordConfirmationRule: [
                    v => !!v || this.$t('Required field'),
                    v => (v && v.length >= 5) || this.$t('Must be at least 5 characters'),
                    (v) => v === this.form.password || this.$t('Password must match'),
                ],
                returnErrors: [],
                dialog: true,
                gender: [
                    {text: this.$t('Male'), value: "m"},
                    {text: this.$t('Female'), value: "n"}
                ],
                form: {
                    firstName: "",
                    lastName: "",
                    phone: "+372 ",
                    address: "",
                    email: ""
                }
            }
        },
        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    //redirectToPayments();
                }
            },
            closeForm: function () {
                this.$refs.form.resetValidation();
                this.$router.go(-1);
            },
            submit() {
                if (this.$refs.form.validate()) {
                    axios.post('/createClientAccount', this.form)
                        .then(response => {
                            this.$router.go(-1);
                            //this.snackbar = true;
                        })
                        .catch(e => {
                            let errors = e.response.data;
                            this.returnErrors =[];
                            for(let key in errors) {
                                for(let error of errors[key] ) {
                                    this.returnErrors.push(error)
                                }
                            }
                        })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
  .v-dialog__content {background: #fff;}
  .container {max-width: 1000px; margin-top: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/account/Register.vue